var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-text"},[_c('div',{staticClass:"vx-row mb-12"},[_c('div',{class:[
			_vm.detail ? _vm.detailShow + ' vertical-divider' : '',
			_vm.detailHide,
		]},[_c('data-table',{attrs:{"responseData":_vm.responseData,"propsParams":_vm.params,"header":_vm.header},on:{"reloadDataFromChild":_vm.reloadData}},[_c('template',{slot:"tbody"},_vm._l((_vm.data),function(tr,indextr){return _c('vs-tr',{key:indextr},[_c('vs-td',[_vm._v(" "+_vm._s(tr.code)+" ")]),_c('vs-td',[_vm._v(" "+_vm._s(tr.count)+" ")])],1)}),1)],2)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }